import { render, staticRenderFns } from "./RdmFooter.vue?vue&type=template&id=2eeb4084&scoped=true&"
import script from "./RdmFooter.vue?vue&type=script&lang=ts&"
export * from "./RdmFooter.vue?vue&type=script&lang=ts&"
import style0 from "./RdmFooter.vue?vue&type=style&index=0&id=2eeb4084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeb4084",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFooter,VRow})
